export const DOCUMENT_CATEGORIES = ['Contratto', 'Mandato di assistenza', 'Comfort letter'];

export const DOCUMENT_STATUSES = [
  { value: 'in_revisione', label: 'In revisione' },
  { value: 'approvato', label: 'Approvato' },
  { value: 'firmato', label: 'Firmato' },
  { value: 'completato', label: 'Completato' },
];

export const DOCUMENT_CREATION_TYPES = [
  {
    value: 'contratto',
    title: 'Contratto',
    description: 'Genera un contratto commerciale',
  },
  {
    value: 'mandato',
    title: 'Mandato di Assistenza',
    description: 'Genera un mandato di assistenza',
  },
];

export function getInitialUploadDocumentForm({ uploadedBy = '' } = {}) {
  const now = new Date();
  const today = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
  return {
    name: '',
    description: '',
    documentDate: today,
    clientId: '',
    client: '',
    category: 'Contratto',
    uploadedBy,
    teamMemberId: '',
    relations: [],
    dueDate: '',
  };
}

export function getInitialMandateForm() {
  return {
    clientId: '',
    client: '',
    firmatario: '',
    firmatarioRuolo: '',
    tipoCrediti: '',
    statoCrediti: '',
    valoreNominale: '',
    valoreStimato: '',
    commissionePercentuale: '',
    dataInizio: '',
    dataScadenza: '',
    accettazionePrivacy: false,
    accettazioneTermini: false,
    modalitaFirma: '',
    luogoFirma: '',
  };
}

export function getInitialContractForm() {
  return {
    clientId: '',
    client: '',
    dataContratto: '',
    luogoContratto: '',
    firmatario: '',
    firmatarioRuolo: '',
    righeCrediti: [
      { id: 1, tipoCredito: '', anno: '', descrizione: '', valoreNominale: '', prezzoAcquisto: '' },
    ],
    tranche: [
      { id: 1, percentuale: '', importo: '', dataScadenza: '', condizione: '' },
    ],
    iban: '',
    nomeBanca: '',
    dichiarazioneTitolarita: false,
    dichiarazioneAssenzaGravami: false,
    accettazione1341_1: false,
    accettazione1341_2: false,
  };
}
